export default {
  'DRAFT': 'dark outline',
  'CUSTOMER_ORDER': 'success outline',
  'INQUIRY': 'primary outline',
  'NEW': 'success outline',
  'SENT_TO_CUSTOMER': 'warning outline',
  'TO_COLLECT': 'danger outline',
  'WAITING_PURCHASE_PRODUCTS': 'danger',
  'ORDER': 'primary',
  'IN_PRODUCTION': 'secondary',
  'TO_CHECK': 'secondary outline',
  'PREPARATION_FOR_SHIPPING': 'warning',
  'WAITING_FOR_SHIPPING': 'info outline',
  'SENT': 'info',
  'PENDING_PAYMENT': 'danger',
  'ENDED': 'success',
  'TO_DELETE': 'dark outline',
  'DELETED': 'dark',
  'OFFER_CLOSED': 'danger outline'
};
